import { useCallback, useEffect, useState } from 'react';

import { api } from '@/services/api';
import { InputWithLabel } from '@/components/shared/InputWithLabel';
import { SelectComponent } from '@/components/shared/SelectComponent';
import { FuncionarioItem } from '@/components/PagesComponents/Comunidade/FuncionarioItem';
import { Loading } from '@/components/shared/Loading';
import { AlertMessage } from '@/components/shared/AlertMessage';
import { SelectItem } from '@/components/ui/select';
import { IUsuario } from '@/@types/Comunidade';
import { DocenteItem } from '@/components/PagesComponents/Comunidade/DocenteItem';

const BuscarContatos = () => {
    const [value, setValue] = useState<string>(''); // valor do input de pesquisa
    const [grupoUsuariosSelecioado, setGrupoUsuariosSelecionado] = useState('Todos'); // valor do select de grupo de usuários

    const [usuariosResult, setUsuariosResult] = useState<IUsuario[]>([]); // resultado da busca baseado nos filtros

    const [alertMessage, setAlertMessage] = useState<string>(''); //mensagem de alerta
    const [isLoading, setIsLoading] = useState<boolean>(true); // inidica se os dados estão sendo carregados

    const filtrarUsuarios = useCallback((data: IUsuario[]): IUsuario[] => {
        // pega apenas os usuários ativos
        let usuarios = data.filter(usuario => usuario.ativo === true);

        // verificar se há um grupo de usuário selecionado
        if (grupoUsuariosSelecioado === 'Funcionarios') {
            // se o grupo selecionado === funcionários
            usuarios = usuarios.filter(usuario => usuario.dn.includes('OU=Funcionarios'));
        }

        if (grupoUsuariosSelecioado === 'Docentes') {
            // se o grupo selecionado === docentes
            usuarios = usuarios.filter(usuario => usuario.dn.includes('OU=Docentes'));
        }

        return usuarios;
    }, [grupoUsuariosSelecioado]);

    useEffect(() => {
        const getUsuarios = async () => {
            setIsLoading(true);
            const url = value.length === 0 ? '/user/register/all/userstartwith/a' : `/user/register/all/userstartwith/${value}`;

            await api.get<IUsuario[]>(url)
                .then(({ data }) => {

                    // filtra os usuários
                    const usuarios = filtrarUsuarios(data);

                    if (usuarios.length === 0) {
                        // se não houver nenhum usuário no resultado
                        setAlertMessage('Nenhum usuário encontrado');
                    }

                    setUsuariosResult(usuarios);
                })
                .catch(err => {
                    console.log(err);
                    setAlertMessage('Algo deu errado, tente novamente mais tarde!');
                })
                .finally(() => setIsLoading(false));
        }

        getUsuarios();
    }, [value, grupoUsuariosSelecioado, filtrarUsuarios]);

    return (
        <div>

            <div>
                <h1>Buscar Contatos</h1>

                <div>
                    <InputWithLabel placeholder='Digite o nome do contato' label='Nome' value={value} onChange={({ target }) => setValue(target.value)} />

                    <SelectComponent placeholder='Selecione o grupo de usuários' label="Grupo de Usuários" className='max-w-sm mt-[20px]' onChange={(value) => setGrupoUsuariosSelecionado(value)}>
                        <SelectItem value='Todos'>Todos</SelectItem>
                        <SelectItem value='Docentes'>Docentes</SelectItem>
                        <SelectItem value='Funcionarios'>Funcionários</SelectItem>
                    </SelectComponent>
                </div>

            </div>

            {isLoading ? (
                <Loading color='primary' />
            ) : (
                <>
                    {usuariosResult.length === 0 ? (
                        <div>
                            <AlertMessage message={alertMessage} />
                        </div>
                    ) : (
                        <div>
                            {/* usuários container */}
                            {usuariosResult.map(usuario => {
                                // Verifica se usuario é definido e se possui a propriedade email
                                if (usuario && usuario.email) {
                                    // Verifica se o email não contém '@dac.unicamp.br'
                                    if (!usuario.email.includes('@dac.unicamp.br')) {
                                        if (usuario.dn.includes('OU=Docentes')) {
                                            return (
                                                <DocenteItem data={usuario} key={usuario._id} />
                                            )
                                        }
                                        return (
                                            <FuncionarioItem data={usuario} key={usuario._id} />
                                        );
                                    }
                                }
                                return null; // Retorna null se não atender aos critérios
                            })}
                        </div>
                    )}
                </>
            )}

        </div>
    )
}

export { BuscarContatos };